import React, { useRef, useState } from 'react';

const PollCommentsModal = ({ user, poll, setPolls }) => {
    const [comment, setComment] = useState('');
    const textareaRef = useRef(null);

    const handleInput = () => {
        const textarea = textareaRef.current;
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    };

    const timeAgo = (createdAt) => {
        const createdDate = new Date(createdAt);
        const now = Date.now();
        const diffInSeconds = Math.floor((now - createdDate) / 1000);

        if (diffInSeconds < 60) {
            return 'Just now';
        } else if (diffInSeconds < 3600) {
            const minutesAgo = Math.floor(diffInSeconds / 60);
            return `${minutesAgo}m`;
        } else if (diffInSeconds < 86400) {
            const hoursAgo = Math.floor(diffInSeconds / 3600);
            return `${hoursAgo}h`;
        } else if (diffInSeconds < 604800) {
            const daysAgo = Math.floor(diffInSeconds / 86400);
            return `${daysAgo}d`;
        } else if (diffInSeconds < 2629746) {
            const weeksAgo = Math.floor(diffInSeconds / 604800);
            return `${weeksAgo}w`;
        }
    };

    const submitComment = (e, pollId) => {
        e.preventDefault();

        if (comment.trim() === '') return;

        setPolls((prevPolls) =>
            Object.keys(prevPolls).reduce((acc, date) => {
                acc[date] = prevPolls[date].map((poll) => {
                    if (poll.id === pollId) {
                        // Add the new comment to the relevant poll
                        return {
                            ...poll,
                            comments: [
                                {
                                    id: Date.now(),
                                    userId: user.id,
                                    name: user.name,
                                    image: user.image,
                                    comment: comment,
                                    edited: false,
                                    created_at: new Date().toISOString(),
                                },
                                ...poll.comments,
                            ],
                        };
                    }
                    return poll;
                });
                return acc;
            }, {})
        );

        setComment('');
        handleInput();

        console.log(window.url.submitComment);
    };

    const likeComment = (e, pollId, commentId, userId) => {
        e.preventDefault();

        setPolls((prevPolls) =>
            Object.keys(prevPolls).reduce((acc, date) => {
                acc[date] = prevPolls[date].map((poll) => {
                    if (poll.id === pollId) {
                        // Update the relevant poll
                        return {
                            ...poll,
                            comments: poll.comments.map((comment) => {
                                if (comment.id === commentId) {
                                    // Ensure likes is an array
                                    const currentLikes = comment.likes || [];

                                    // Check if the user has already liked this comment
                                    const hasLiked = currentLikes.some(
                                        (like) => like.id === userId
                                    );

                                    // If the user has liked the comment, remove their like
                                    // Otherwise, add their like
                                    return {
                                        ...comment,
                                        likes: hasLiked
                                            ? currentLikes.filter(
                                                  (like) => like.id !== userId
                                              ) // Remove like
                                            : [
                                                  {
                                                      id: userId,
                                                      name: user.name,
                                                      image: user.image,
                                                  },
                                                  ...currentLikes,
                                              ], // Add like
                                    };
                                }
                                return comment; // Return other comments unchanged
                            }),
                        };
                    }
                    return poll; // Return other polls unchanged
                });
                return acc;
            }, {})
        );

        console.log(window.url.likeComment);
    };

    const editComment = (e, pollId, commentId, userId) => {
        e.preventDefault();

        console.log(window.url.editComment);
    };

    const deleteComment = (e, pollId, commentId, userId) => {
        e.preventDefault();

        console.log(window.url.deleteComment);
    };

    return (
        <div>
            <dialog
                id={`card-${poll.id}-modal`}
                className='modal overflow-auto p-10'>
                <div
                    key={poll.id}
                    className='card card-compact min-w-[295px] max-w-[600px] w-[65%] shadow-xl bg-white/80 backdrop-blur-lg '>
                    <form method='dialog'>
                        <button className='btn btn-sm btn-circle btn-ghost absolute right-2 top-2'>
                            ✕
                        </button>
                    </form>
                    <div className='w-full h-[277px] rounded-t-box overflow-hidden'>
                        {poll.options.length === 2 &&
                        poll.options.every(
                            (option) =>
                                option.image && option.image.trim() !== ''
                        ) ? (
                            <div className='w-full h-full flex gap-1'>
                                {poll.options.map((option) => (
                                    <figure
                                        key={`image-${poll.id}-${option.id}`}
                                        className='w-full h-full bg-cover bg-center rounded-none opacity-100'
                                        style={{
                                            backgroundImage: `url(${option.image})`,
                                        }}></figure>
                                ))}
                            </div>
                        ) : (
                            <figure
                                className='w-full h-full bg-cover bg-center'
                                style={{
                                    backgroundImage: `url(${poll.image})`,
                                }}></figure>
                        )}
                    </div>
                    <div className='card-body'>
                        <h2 className='card-title'>{poll.question}</h2>
                    </div>
                    <div className='card-body !p-0 gap-0 justify-end'>
                        <div className='flex flex-col p-4 gap-2'>
                            {poll.options.map((option) => {
                                const totalVotes = poll.options.reduce(
                                    (voteCount, option) =>
                                        voteCount + Number(option.votes.length),
                                    0
                                );

                                let percentageWidth = 0;

                                percentageWidth =
                                    totalVotes > 0
                                        ? Math.round(
                                              (Number(option.votes.length) /
                                                  totalVotes) *
                                                  100
                                          )
                                        : 0;

                                return (
                                    <div key={`option-${poll.id}-${option.id}`}>
                                        <div className='relative rounded-box border-2 border-[#58b4ff]  flex items-center justify-between overflow-hidden'>
                                            <div
                                                className={`absolute inset-0 bg-[#58b4ff] transition-all duration-500 ease-out`}
                                                style={{
                                                    width: `${percentageWidth}%`,
                                                }}
                                            />
                                            <label className='flex items-center gap-2 p-3 flex-1 z-10'>
                                                <label className='relative flex justify-center items-center'>
                                                    <span className='absolute bg-[#187cb5] w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'></span>
                                                </label>
                                                <span className='font-bold'>
                                                    {option.text}
                                                </span>
                                            </label>
                                            <div
                                                className='flex items-center p-3 cursor-pointer z-10'
                                                onClick={() =>
                                                    document
                                                        .getElementById(
                                                            `poll-card-modal-${poll.id}-${option.id}`
                                                        )
                                                        .showModal()
                                                }
                                                title='View Votes'>
                                                <span className='font-bold'>
                                                    {poll.options.length > 1
                                                        ? `${Math.round(
                                                              percentageWidth
                                                          )}%`
                                                        : option.votes.length}
                                                </span>

                                                <svg
                                                    width={20}
                                                    height={20}
                                                    fill='none'
                                                    stroke='currentColor'
                                                    strokeLinecap='round'
                                                    strokeLinejoin='round'
                                                    strokeWidth={2.5}
                                                    viewBox='0 0 24 24'
                                                    xmlns='http://www.w3.org/2000/svg'>
                                                    <path d='m9 18 6-6-6-6' />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className='card-actions flex justify-end items-end px-4'>
                            {poll.comments.length > 0 && (
                                <span
                                    className='opacity-80 hover:underline cursor-pointer'
                                    onClick={() =>
                                        document
                                            .getElementById(
                                                `card-${poll.id}-modal`
                                            )
                                            .showModal()
                                    }>
                                    {poll.comments.length}{' '}
                                    {poll.comments.length === 1
                                        ? 'comment'
                                        : 'comments'}
                                </span>
                            )}
                        </div>
                        <div className='divider m-0'></div>
                        <div className='card-body gap-5'>
                            <div className='flex gap-3'>
                                <div className='avatar w-10 h-10'>
                                    <div className='w-full rounded-full'>
                                        <img
                                            src={user.image}
                                            className='w-full'
                                            alt='user'
                                            loading='lazy'
                                        />
                                    </div>
                                </div>
                                <div className='flex-1'>
                                    <form
                                        onSubmit={(e) => {
                                            submitComment(e, poll.id);
                                        }}
                                        className='w-full h-auto rounded-box bg-[#c3c3c3] px-5 py-3 flex flex-col items-end'>
                                        <textarea
                                            className='textarea textarea-ghost w-full p-0 border-none bg-transparent text-[#333] focus:text-[#333] focus:outline-none leading-5 min-h-[40px] resize-none'
                                            placeholder={`Comment as ${user.name}`}
                                            ref={textareaRef}
                                            onInput={handleInput}
                                            value={comment}
                                            onChange={(e) =>
                                                setComment(e.target.value)
                                            }></textarea>
                                        <button
                                            type='submit'
                                            className='w-[30px] h-[30px] rounded-full flex justify-center items-center bg-transparent hover:bg-white/25 border-none mt-[-px]'
                                            title='Submit comment'>
                                            <svg
                                                width={15}
                                                height={15}
                                                fill='none'
                                                stroke='#187cb5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                                strokeWidth={2.5}
                                                viewBox='0 0 24 24'
                                                xmlns='http://www.w3.org/2000/svg'>
                                                <path d='M22 2 11 13' />
                                                <path d='m22 2-7 20-4-9-9-4 20-7z' />
                                            </svg>
                                        </button>
                                    </form>
                                </div>
                            </div>

                            {poll.comments.map((comment) => {
                                return (
                                    <div
                                        key={`comment-${poll.id}-${comment.id}`}
                                        className='flex gap-3'>
                                        <div className='avatar w-10 h-10'>
                                            <div className='w-full rounded-full'>
                                                <img
                                                    src={comment.image}
                                                    className='w-full'
                                                    alt='user'
                                                    loading='lazy'
                                                />
                                            </div>
                                        </div>
                                        <div className='flex-1'>
                                            <div>
                                                <div className='w-full h-auto rounded-box flex justify-between bg-[#c3c3c3] px-5 py-3'>
                                                    <div>
                                                        <p>
                                                            <span className='font-bold'>
                                                                {comment.name}
                                                            </span>
                                                            {comment.edited && (
                                                                <span className='badge badge-outline badge-sm ml-2'>
                                                                    Edited
                                                                </span>
                                                            )}
                                                        </p>
                                                        <p>{comment.comment}</p>
                                                    </div>
                                                    {comment.userId ===
                                                        user.id && (
                                                        <div className='dropdown dropdown-start'>
                                                            <div
                                                                className='opacity-50 hover:opacity-100 cursor-pointer'
                                                                tabIndex={0}>
                                                                <svg
                                                                    xmlns='http://www.w3.org/2000/svg'
                                                                    fill='none'
                                                                    viewBox='0 0 24 24'
                                                                    className='inline-block h-5 w-5 stroke-current'>
                                                                    <path
                                                                        strokeLinecap='round'
                                                                        strokeLinejoin='round'
                                                                        strokeWidth='2'
                                                                        d='M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z'></path>
                                                                </svg>
                                                            </div>
                                                            <ul
                                                                tabIndex={0}
                                                                className='dropdown-content menu bg-[#dedede] rounded-box w-52 p-2 shadow'>
                                                                <li>
                                                                    <span
                                                                        onClick={(
                                                                            e
                                                                        ) => {
                                                                            editComment(
                                                                                e,
                                                                                poll.id,
                                                                                comment.id,
                                                                                user.id
                                                                            );
                                                                        }}>
                                                                        Edit
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span
                                                                        onClick={(
                                                                            e
                                                                        ) => {
                                                                            deleteComment(
                                                                                e,
                                                                                poll.id,
                                                                                comment.id,
                                                                                user.id
                                                                            );
                                                                        }}>
                                                                        Delete
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className='ml-2 mt-1 font-bold text-xs flex gap-4'>
                                                    <span>
                                                        {timeAgo(
                                                            comment.created_at
                                                        )}
                                                    </span>

                                                    <span
                                                        className={`underline cursor-pointer select-none ${
                                                            comment.likes?.some(
                                                                (like) =>
                                                                    like.id ===
                                                                    user.id
                                                            )
                                                                ? 'text-[#187cb5]'
                                                                : ''
                                                        }`}
                                                        onClick={(e) => {
                                                            likeComment(
                                                                e,
                                                                poll.id,
                                                                comment.id,
                                                                user.id
                                                            );
                                                        }}
                                                        title='Like comment'>
                                                        Like
                                                    </span>

                                                    {comment.likes &&
                                                        comment.likes.length >
                                                            0 && (
                                                            <>
                                                                <span
                                                                    className='flex gap-1 cursor-pointer'
                                                                    title='View likes'
                                                                    onClick={() =>
                                                                        document
                                                                            .getElementById(
                                                                                `poll-comment-modal-${poll.id}-${comment.id}`
                                                                            )
                                                                            .showModal()
                                                                    }>
                                                                    {
                                                                        comment
                                                                            .likes
                                                                            .length
                                                                    }
                                                                    <svg
                                                                        width={
                                                                            15
                                                                        }
                                                                        height={
                                                                            15
                                                                        }
                                                                        fill={
                                                                            comment.likes.some(
                                                                                (
                                                                                    like
                                                                                ) =>
                                                                                    like.id ===
                                                                                    user.id
                                                                            )
                                                                                ? '#187cb5'
                                                                                : 'none'
                                                                        } // Change fill color
                                                                        stroke={
                                                                            comment.likes.some(
                                                                                (
                                                                                    like
                                                                                ) =>
                                                                                    like.id ===
                                                                                    user.id
                                                                            )
                                                                                ? '#187cb5'
                                                                                : 'currentColor'
                                                                        } // Change stroke color
                                                                        strokeLinecap='round'
                                                                        strokeLinejoin='round'
                                                                        strokeWidth={
                                                                            2.5
                                                                        }
                                                                        viewBox='0 0 24 24'
                                                                        xmlns='http://www.w3.org/2000/svg'>
                                                                        <path d='M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3' />
                                                                    </svg>
                                                                </span>
                                                                <dialog
                                                                    id={`poll-comment-modal-${`${poll.id}-${comment.id}`}`}
                                                                    className='modal overflow-auto p-10'>
                                                                    <div className='card card-compact w-full max-w-[400px] shadow-xl bg-white/80 backdrop-blur-lg text-[#333]'>
                                                                        <form method='dialog'>
                                                                            <button className='btn btn-sm btn-circle btn-ghost absolute right-2 top-2'>
                                                                                ✕
                                                                            </button>
                                                                        </form>
                                                                        <div className='card-body'>
                                                                            <h2 className='card-title justify-center'>
                                                                                Likes
                                                                            </h2>
                                                                            <div className='divider m-0'></div>
                                                                            {comment.likes.map(
                                                                                (
                                                                                    user
                                                                                ) => {
                                                                                    return (
                                                                                        <div
                                                                                            key={`${poll.id}-${comment.id}-${user.id}`}
                                                                                            className='flex gap-2 items-center'>
                                                                                            <div className='avatar w-10 h-10'>
                                                                                                <div className='w-full rounded-full'>
                                                                                                    <img
                                                                                                        src={
                                                                                                            user.image
                                                                                                        }
                                                                                                        className='w-full'
                                                                                                        alt='user'
                                                                                                        loading='lazy'
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <span className='font-bold'>
                                                                                                {
                                                                                                    user.name
                                                                                                }
                                                                                            </span>
                                                                                        </div>
                                                                                    );
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </dialog>
                                                            </>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </dialog>
        </div>
    );
};

export default PollCommentsModal;
